angular.module('app').factory('FormBuilder', function () {
    function makeRow(rowFields) {
        var row = {
            className: "row",
            fieldGroup: []
        };
        _(rowFields).forEach(function (field) {
            var fieldGroupItem = {
                className: "col-md-" + field.width,
                key: field.key,
                type: "input",
                templateOptions: {
                    type: "text",
                    label: field.description,
                    placeholder: field.description,
                    required: true
                }
            };
            row.fieldGroup.push(fieldGroupItem);
        });
        return row;
    }
    function buildForm(card) {
        var formFields = [];
        var numberFields = [
            { key: "TestCardNumber", width: 6, description: "Test Card Number" },
            { key: "TrackIIInformation", width: 6, description: "Track II Information" }
        ];
        formFields.push(makeRow(numberFields));
        var pinFields = [
            { key: "PIN", width: 6, description: "PIN" },
            { key: "CVC", width: 3, description: "CVC" },
            { key: "CVC2", width: 3, description: "CVC2" }
        ];
        formFields.push(makeRow(pinFields));
        var addressFields = [
            { key: "Address", width: 6, description: "Address" },
            { key: "ZIP", width: 3, description: "ZIP" }
        ];
        formFields.push(makeRow(addressFields));
        // NOTE: We only need the emv fields where the test card isEmv = true
        if (card.IsEmv) {
            var emvFields1 = [
                { key: "CardSequenceNumber", width: 6, description: "Card Sequence Number", isEmv: true },
                { key: "ApplicationInterchangeProfile", width: 6, description: "Application Interchange Profile", isEmv: true }
            ];
            formFields.push(makeRow(emvFields1));
            var emvFields2 = [
                { key: "DerivationKeyIndex", width: 6, description: "Derivation Key Index", isEmv: true },
                { key: "CryptogramVersionNumber", width: 6, description: "Cryptogram Version Number", isEmv: true }
            ];
            formFields.push(makeRow(emvFields2));
            var emvFields3 = [
                { key: "IssueMasterKeyApplication", width: 6, description: "Issue Master Key Application", isEmv: true }
            ];
            formFields.push(makeRow(emvFields3));
        }
        return formFields;
    }
    var fac = {
        makeRow: makeRow,
        buildForm: buildForm
    };
    return fac;
});
//# sourceMappingURL=FormBuilder.service.js.map